 import { ModuleWithProviders } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

//componentrs
import { AppComponent } from './app.component';
import { PagesComponent } from './pages/pages.component';

const appRoutes: Routes =[

    {path: '', component: PagesComponent, loadChildren: './pages/pages.module#PagesModule'}
];

 export const appRoutingProviders: any[]=[];
 export const routing: ModuleWithProviders = RouterModule.forRoot(appRoutes);

//export const routing = RouterModule.forRoot( appRoutes);



// WEBPACK FOOTER //
// F:/node/angular/complejidadesFrontend/src/app/app.routing.ts